import React from 'react';
import { MapPinIcon, SignalIcon, CreditCardIcon, ZapIcon, LifeBuoyIcon } from 'lucide-react';
export function TopBanner() {
  const menuItems = [{
    label: 'Find a Store',
    icon: MapPinIcon
  }, {
    label: 'Coverage',
    icon: SignalIcon
  }, {
    label: 'Pay Bill',
    icon: CreditCardIcon
  }, {
    label: 'Activate',
    icon: ZapIcon
  }, {
    label: 'Support',
    icon: LifeBuoyIcon
  }];
  return <div className="bg-[#111111] text-white py-2 border-b border-white/5 relative z-[60]" data-id="element-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="flex justify-end items-center gap-8 text-[10px] font-black uppercase tracking-[0.15em]" data-id="element-202">
          {menuItems.map(item => <a key={item.label} href={`#${item.label.toLowerCase().replace(/\s+/g, '-')}`} className="flex items-center gap-2 hover:text-[#13E200] transition-colors duration-200 group" data-id="element-203">
              <item.icon className="w-3 h-3 text-[#13E200] group-hover:scale-110 transition-transform" data-id="element-204" />
              {item.label}
            </a>)}
        </div>
      </div>
    </div>;
}